import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class CaptainForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            selected: {
                email: "",
                team: "",
                id: '',
                created: '',
                league_id: 0,
                league: '',
                team_id: 0
            },
            flag: true,
            teams: props.teams,
            selectedOption: ''
        };
    }

    componentWillMount(){
        let st = {...this.props.selected}
        if(!st.team){
            st.team=""
            st.league=""
        }
        this.setState({selected: st});
    }

    handleKeyPress(e){
        if (e.key === 'Enter') {
            if(!this.props.selected){
                this.props.save(this.state.selected)
            }else{
                this.props.edit(this.state.selected)
            }
        }
    }

    handleChange = (selectedOption) => {
        let st = {...this.state}
        st.selected.team_id = selectedOption.value
        st.selected.team = selectedOption.label
        st.selected.league_id = selectedOption.league_id
        this.setState(st)
        this.setState({ selectedOption });
    }

    randomString(length) {
        let chars = 'abcdefghijklmnopqrstuvwxyz0123456789!¡¿?=)(%$+-';
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        let st = {...this.state}
        st.selected.password = result;
        this.setState(st)
    }

    render(){
        return(
            <div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Usuario</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="email" autoFocus onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Correo" value={this.state.selected.email} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.email = e.currentTarget.value;
                            this.setState(state);
                        }} />
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="label">Contraseña</label>
                    </div>
                    <div className="field-body">
                        <input className="input" type="text" onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Contraseña" value={this.state.selected.password} onChange={(e) => {
                            let state = {...this.state};
                            state.selected.password = e.currentTarget.value;
                            this.setState(state);
                        }} />
                        <button onClick={()=>this.randomString(10)}>Random</button>
                    </div>
                </div>
                <div className="FieldHorizontal field is-horizontal">
                    <div className="field-label">
                        <label className="radio">
                            <input type="radio" defaultChecked name="team_radio" onChange={()=>{
                                let st = {...this.state}
                                st.flag = true;
                                this.setState(st)
                            }} />
                            Nuevo
                        </label>
                        <label className="radio">
                            <input type="radio" name="team_radio" onChange={()=>{
                                let st = {...this.state}
                                st.flag = false;
                                this.setState(st)
                            }}/>
                            Existente
                        </label>
                    </div>
                </div>
                {this.state.flag &&
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Equipo</label>
                        </div>
                        <div className="field-body">
                            {this.props.selected == null ?
                                <input className="input" type="text" onKeyPress={(e) => this.handleKeyPress(e)} placeholder="Equipo" value={this.state.selected.team} onChange={(e) => {
                                    let state = {...this.state};
                                    state.selected.team = e.currentTarget.value;
                                    this.setState(state);
                                }} />
                                : this.state.selected.team
                            }
                            
                        </div>
                    </div>
                }
                {this.state.flag &&
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Liga</label>
                        </div>
                        <div className="field-body">
                            {!this.props.selected ?
                                <select
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    className="input"
                                    onChange={(e) => {
                                        let state = {...this.state};
                                        let index = e.currentTarget.selectedIndex -1;
                                        state.selected.league_id = this.props.leagues[index].id;
                                        state.selected.league = this.props.leagues[index].name;
                                    }}
                                >
                                    <option disabled={true} selected={true}>Seleccionar...</option>
                                    {this.props.leagues.map(l => {
                                        return (
                                            <option key={l.id} selected={l.id==this.state.selected.league_id ? "selected" :"" }>
                                                {l.name +" -- "+l.tournament_name}
                                            </option>
                                        )
                                    })}

                                </select>
                                : this.state.selected.league
                            }
                        </div>
                    </div>
                }
                {!this.state.flag && 
                    <div className="FieldHorizontal field is-horizontal">
                        <div className="field-label">
                            <label className="label">Equipo</label>
                        </div>
                        <div className="field-body">
                            <Select className="input"
                                name="form-field-name"
                                options={this.state.teams}
                                value={this.state.selectedOption}
                                onChange={this.handleChange}
                            />
                        </div>
                    </div>
                }
                <div className="columns has-text-right buttons-modal">
                    <div className="column">
                        {!this.props.selected ?
                            <button className="button is-success" onClick={() => this.props.save(this.state.selected)}>Guardar</button>
                            :<button className="button is-success" onClick={() => this.props.edit(this.state.selected)}>Editar</button>
                       }
                        <button className="button" onClick={() => this.props.cancel()}>Cancelar</button>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/captains/CaptainForm.js